// import React from 'react'
import { useLocation } from 'react-router-dom'
import SchoolBreadcrumb from './schoolBreadcrumb'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../core/data/redux/store'
import { getSchoolById, fetchSchoolTypesApi, fetchSchoolLocationTypesApi, fetchSchoolAreaTypesApi } from '../../../../core/data/services/schoolService'
import { fetchStates, fetchDistricts, fetchBlocks, fetchVillages } from '../../../../core/data/services/stateDistrictBlockService'
import { setSelectedSchool } from '../../../../core/data/redux/schoolSlice'
import { useEffect, useState } from 'react'

const SchoolDetails = () => {
  // const routes = all_routes
  const location = useLocation();
  const dispatch = useDispatch()
  const schoolFromState = location.state?.school;

  const [typeIdToName, setTypeIdToName] = useState<Record<number, string>>({});
  const [locationTypeIdToName, setLocationTypeIdToName] = useState<Record<number, string>>({});
  const [areaTypeIdToName, setAreaTypeIdToName] = useState<Record<number, string>>({});

  const [stateIdToName, setStateIdToName] = useState<Record<number, string>>({});
  const [districtIdToName, setDistrictIdToName] = useState<Record<number, string>>({});
  const [blockIdToName, setBlockIdToName] = useState<Record<number, string>>({});
  const [villageIdToName, setVillageIdToName] = useState<Record<number, string>>({});

  console.log("Student Details:", schoolFromState);

  // Get user data from Redux
  const user = useSelector((state: RootState) => state.user);
  const schoolId = schoolFromState?.id;

  useEffect(() => {
    const loadSchoolData = async () => {
      try {
        const school = await getSchoolById(schoolId);
        if (school) {
          dispatch(setSelectedSchool(school));
        } else {
          console.error('School not found for user:', user.Users[0]?.relatedEntity?.schools?.name);
        }
      } catch (error) {
        console.error('Error loading school data:', error);
      }
    };

    if (user && user.Users.length > 0) {
      loadSchoolData();
    }
  }, [dispatch, user, schoolId]);

  // Fetch type lists and build maps
  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const [schoolTypes, locationTypes, areaTypes] = await Promise.all([
          fetchSchoolTypesApi(),
          fetchSchoolLocationTypesApi(),
          fetchSchoolAreaTypesApi(),
        ]);

        const typeMap: Record<number, string> = {};
        schoolTypes.forEach((t) => { typeMap[t.id] = t.name; });
        setTypeIdToName(typeMap);

        const locationMap: Record<number, string> = {};
        locationTypes.forEach((t) => { locationMap[t.id] = t.name; });
        setLocationTypeIdToName(locationMap);

        const areaMap: Record<number, string> = {};
        areaTypes.forEach((t) => { areaMap[t.id] = t.name; });
        setAreaTypeIdToName(areaMap);
      } catch (error) {
        console.error('Error fetching type lists:', error);
      }
    };

    fetchTypes();
  }, []);

  // Fetch geo names for state/district/block/village
  useEffect(() => {
    const loadGeo = async () => {
      try {
        const states = await fetchStates();
        const stateMap: Record<number, string> = {};
        states.forEach(s => { stateMap[s.id as unknown as number] = s.name as unknown as string; });
        setStateIdToName(stateMap);

        if (schoolFromState?.stateId) {
          const districts = await fetchDistricts(Number(schoolFromState.stateId));
          const districtMap: Record<number, string> = {};
          districts.forEach(d => { districtMap[d.id as unknown as number] = d.name as unknown as string; });
          setDistrictIdToName(districtMap);

          if (schoolFromState?.districtId) {
            const blocks = await fetchBlocks(Number(schoolFromState.stateId), Number(schoolFromState.districtId));
            const blockMap: Record<number, string> = {};
            blocks.forEach(b => { blockMap[b.id as unknown as number] = b.name as unknown as string; });
            setBlockIdToName(blockMap);

            if (schoolFromState?.blockAreaId) {
              const villages = await fetchVillages(Number(schoolFromState.stateId), Number(schoolFromState.districtId), Number(schoolFromState.blockAreaId));
              const villageMap: Record<number, string> = {};
              villages.forEach(v => { villageMap[v.id as unknown as number] = v.name as unknown as string; });
              setVillageIdToName(villageMap);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching location names:', error);
      }
    };

    loadGeo();
  }, [schoolFromState?.stateId, schoolFromState?.districtId, schoolFromState?.blockAreaId, schoolFromState?.villageWardId]);

  const selectSchool = useSelector((state: RootState) => state.school.selectedSchool)
  console.log("schoolList", selectSchool)


  if (!schoolFromState) {
    return <div>School not found</div>;
  }

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <SchoolBreadcrumb schoolFromState={schoolFromState} />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* /Student Information */}
            <div className="col-xxl-12 col-xl-12">
              <div className="row">
                <div className="col-md-12">
                  {/* Parents Information */}
                  <div className="card">
                    <div className="card-header">
                      <h5>Basic Information</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">
                              School Name
                            </p>
                            <p>{selectSchool?.name}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">School Code</p>
                            <p>{schoolFromState?.schoolCode}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">UDISE Code</p>
                            <p>{schoolFromState?.udiseCode}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Email</p>
                            <p>{schoolFromState?.email ?? 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Phone</p>
                            <p>{schoolFromState?.phone ?? 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Website</p>
                            <p>{schoolFromState?.website ?? 'NA'}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Parents Information */}
                </div>
                {/* Address */}
                <div className="col-xxl-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <h5>Address</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-6 col-lg-4">
                          <div className="d-flex align-items-center mb-3">
                            <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                              <i className="ti ti-map-pin-up" />
                            </span>
                            <div>
                              <p className="text-dark fw-medium mb-1">
                                Address
                              </p>
                              <p>{schoolFromState?.address}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">📍 Coordinates</p>
                            <p>Lat: {schoolFromState?.latitude?.toFixed(6)} | Lng: {schoolFromState?.longitude?.toFixed(6)}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Gender</p>
                            <p>{schoolFromState?.gender}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Shift</p>
                            <p>{schoolFromState?.shift}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Type</p>
                            <p>{schoolFromState?.typeId ? (typeIdToName[schoolFromState.typeId] ?? schoolFromState.typeId) : 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Location Type</p>
                            <p>{schoolFromState?.locationTypeId ? (locationTypeIdToName[schoolFromState.locationTypeId] ?? schoolFromState.locationTypeId) : 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Area Type</p>
                            <p>{schoolFromState?.areaTypeId ? (areaTypeIdToName[schoolFromState.areaTypeId] ?? schoolFromState.areaTypeId) : 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Established Year</p>
                            <p>{schoolFromState?.establishedYear ?? 'NA'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Bal Vatika</p>
                            <p>{schoolFromState?.balVatika ? 'Yes' : 'No'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Primary</p>
                            <p>{schoolFromState?.primary ? 'Yes' : 'No'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Upper Primary</p>
                            <p>{schoolFromState?.upperPrimary ? 'Yes' : 'No'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Secondary</p>
                            <p>{schoolFromState?.secondary ? 'Yes' : 'No'}</p>
                          </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Higher Secondary</p>
                            <p>{schoolFromState?.higherSecondary ? 'Yes' : 'No'}</p>
                          </div>
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">State</p>
                            <p>{schoolFromState?.stateId ? (stateIdToName[Number(schoolFromState.stateId)] ?? schoolFromState.stateId) : 'NA'}</p>
                          </div>
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">District</p>
                            <p>{schoolFromState?.districtId ? (districtIdToName[Number(schoolFromState.districtId)] ?? schoolFromState.districtId) : 'NA'}</p>
                          </div>
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Block</p>
                            <p>{schoolFromState?.blockAreaId ? (blockIdToName[Number(schoolFromState.blockAreaId)] ?? schoolFromState.blockAreaId) : 'NA'}</p>
                          </div>
                        </div>
                        
                        <div className="col-sm-6 col-lg-4">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Village</p>
                            <p>{schoolFromState?.villageWardId ? (villageIdToName[Number(schoolFromState.villageWardId)] ?? schoolFromState.villageWardId) : 'NA'}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <StudentModals /> */}
    </>

  )
}

export default SchoolDetails